import { ICompanyBankAccountEntity } from "@odata/GeneratedEntityTypes";
import { isDefined, isObjectEmpty } from "@utils/general";

export const isBankApiConnected = (bankAccount: ICompanyBankAccountEntity): boolean => {
    return isDefined(bankAccount?.BankApiConnectionSetting?.ApiKeyId) && !isObjectEmpty(bankAccount?.BankApiStatementImportSetting);
};